import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';

import {
  GET_SEDES_REQUEST,
} from '../../actions/constants/sedes/sedes.constants';
import { authRequest } from '../../../helpers/request.helper';
import {
  getSedesFailureAction,
  getSedesSuccessAction,
} from '../../actions/creators/sedes/sedes.actioncreator';

const getSedesFromState = state => state.clientes;

function* getSedes(action) {
  const { payload } = action;
  const {
    page, start, limit,
  } = payload;

  const params = {
    url: `sedes/?page=${page}&start=${start}&limit=${limit}`,
    method: 'GET',
  };

  try {
    const response = yield call(authRequest, params);
    const { datos, success, total } = response;
    if (success) {
      const sedesFromState = yield select(getSedesFromState);

      yield put(getSedesSuccessAction(datos, total, page, start, limit));
    } else {
      yield put(getSedesFailureAction());
    }
  } catch (error) {
    yield put(getSedesFailureAction(error));
  }
}

export function* getSedesRequest() {
  yield takeLatest(GET_SEDES_REQUEST, getSedes);
}
